import React from "react";
import { TRACK_STATUS_URL } from "../../config/constant";

const HomeBanner = () => {

  return (
    <div
      className={`bg-cover bg-center bg-no-repeat my-8 mx-3 sm:mx-6 sm:my-8 rounded-3xl bg-home-banner-mobile sm:bg-home-banner`}
    >
      {/* Responsive Container */}
      <div className="flex flex-col justify-between h-[210px] sm:h-[70vh] lg:h-[500px]">
        
        {/* Top Section: Heading, Subheading and Sign Up Button */}
        <div className="flex flex-col items-center justify-center space-y-1 sm:space-y-3 px-6 sm:px-12 md:px-16 lg:px-24 py-2 sm:py-6">
          <h1 className="font-bold text-white text-lg sm:text-3xl md:text-4xl lg:text-5xl text-center">
            Customs Compliance
          </h1>
          <p className="text-xs sm:text-base md:text-lg lg:text-xl text-white text-center">
            An End-to-End Logistics & Supply Chain Service Provider
          </p>
        </div>

        {/* Bottom Section: Track Shipment Status */}

<div className="flex items-center justify-center mb-4 sm:mb-8 px-4">
  <div className="bg-white rounded-lg p-2 sm:p-4 shadow-lg flex items-center space-x-2 sm:space-x-4 w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl">
    <button onClick={() => window.open(TRACK_STATUS_URL, '_blank')}  className="bg-[#1A48BF] hover:bg-[#163a8c] text-white text-xs sm:text-sm md:text-base h-10 sm:h-12 rounded-md shadow-md flex-grow px-4 transition duration-300 ease-in-out transform hover:scale-105">
      <p className="text-white text-xs sm:text-sm md:text-base lg:text-lg">
        Track my status
      </p>
    </button>
  </div>
</div>

      </div>
    </div>
  );
};

export default HomeBanner;
